<template>
    <div>
        <div style="width: 1200px;margin: 0 auto;" class="crumbs">
            <span style="cursor: pointer;" @click="Jump({path:'/'})">{{$t('view.首页')}}</span><span style="margin: 0 5px">></span>
            <span style="cursor: pointer;" @click="Jump({path:'/showList',query:{biddingType:bidSection.biddingType}})">{{  bidSection.biddingType==1?$t('view.询价'):$t('view.招标')}}</span><span style="margin: 0 5px;color: #333333;">></span>
            <span style="cursor: pointer;" @click="Jump({path:'/showList',query:{projectType:bidSection.projectType,biddingType:bidSection.biddingType}})">{{getStatus('sys_section_type',bidSection.projectType)}}</span><span style="margin: 0 5px">></span>
            <span>{{ locale=='en'? bidSection.sectionNameEn:locale=='lo'?bidSection.sectionNameLo:bidSection.sectionName}}</span>
        </div>
        <div style="background: #fff">
            <div style="width: 1200px;margin: 0 auto">
                <div class="title">{{  locale=='en'? bidSection.sectionNameEn:locale=='lo'?bidSection.sectionNameLo:bidSection.sectionName }}</div>
                <div class="time">{{$t('view.发布时间：')}}{{ bidSection.createTime }}</div>
                <!-- 信息 -->
                <el-table :cell-style='rowClass'  :span-method="objectSpanMethod"  :show-header="false" :data="tableData" border style="margin: 20px 0; width:100%">
                    <el-table-column align="center" width="150" prop="LeftTitle">
                        <template slot-scope="scope">
                            {{ scope.row.LeftTitle?scope.row.LeftTitle:'/' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="LeftValue">
                         <template slot-scope="scope">
                            {{ scope.row.LeftValue?scope.row.LeftValue:'/' }}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="150" prop="RightTitle">
                         <template slot-scope="scope">
                            {{ scope.row.RightTitle?scope.row.RightTitle:'/' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="RightValue">
                        <template slot-scope="scope">
                          <span v-if="scope.row.RightValue!=$t('view.是否提交投标文件')">{{scope.row.RightValue?scope.row.RightValue:'/'}}</span>
                          <span v-else-if="bidSection.isCommitBusinessFile!=1 &&bidSection.isCommitTechnicalFile!=1">{{$t('view.否')}}</span>
                          <span v-else>
                                <el-checkbox true-label="1" false-label="0" v-model="bidSection.isCommitBusinessFile" disabled>{{$t('view.商务文件')}}</el-checkbox>
                                <el-checkbox true-label="1" false-label="0" v-model="bidSection.isCommitTechnicalFile" disabled>{{$t('view.技术文件')}}</el-checkbox>
                          </span>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 招标公告 -->
                <div class="title">{{$t('view.招标公告')}}</div>
                <div v-if="locale=='lo'" class="border borderBottom"  v-html="bidSection.projectNotesLo"></div>
                <div v-else-if="locale=='en'" class="border borderBottom"  v-html="bidSection.projectNotesEn"></div>
                <div v-else class="border borderBottom"  v-html="bidSection.projectNotes"></div>
                <!-- 收费信息 -->
                <!-- {{bidSection.receivingAccountList}} -->
                <div class="border" v-if="bidSection.receivingAccountList&&bidSection.receivingAccountList.length">
                    <div class="title" style="text-align: left">{{$t('view.收费信息')}}</div>
                    <el-table :data="bidSection.receivingAccountList" border header-row-class-name="tableHeader" style="width: 100%" >
                        <el-table-column align="center" prop="date" :label="$t('view.类型')" width="200">
                            <template slot-scope="scope">
                                {{getStatus('sys_receiving_account_type',scope.row.type)}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="money" :label="$t('view.金额')" width="180">
                            <template slot-scope="scope">
                                {{formatNum(scope.row.money)}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="date" :label="$t('view.币种')" width="180">
                            <template slot-scope="scope">
                                {{getStatus('sys_currency',scope.row.currency)}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="bankAccountName" :label="$t('view.账号名称')">
                            <template slot-scope="scope">
                                {{scope.row.bankAccountName}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="bankAccount" :label="$t('view.账号')">
                            <template slot-scope="scope">
                                {{scope.row.bankAccount}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="openAccountBank" :label="$t('view.开户行')"></el-table-column>
                    </el-table>
                </div>
                <!-- 投标人资质要求 -->
                <div class="border" v-if="bidSection.isQualificationBusinessLicense==1||bidSection.isQualificationOther==1||bidSection.isQualificationAchievement==1||bidSection.isQualificationAgencyLicense==1">
                    <div class="title" style="text-align: left">{{$t('view.投标人资质要求')}}</div>
                    <div class="borders border" style="padding: 10px;width: 1180px;">
                        <el-checkbox v-if="bidSection.isQualificationBusinessLicense==1" disabled true-label="1" false-label="0" v-model="bidSection.isQualificationBusinessLicense">{{$t('view.营业执照')}}</el-checkbox>
                        <el-checkbox v-if="bidSection.isQualificationAchievement==1" disabled true-label="1" false-label="0" v-model="bidSection.isQualificationAchievement">{{$t('view.业绩')}}</el-checkbox>
                        <el-checkbox v-if="bidSection.isQualificationAgencyLicense==1" disabled true-label="1" false-label="0" v-model="bidSection.isQualificationAgencyLicense">{{$t('view.代理许可证')}}</el-checkbox>
                        <el-checkbox v-if="bidSection.isQualificationOther==1" disabled true-label="1" false-label="0" v-model="bidSection.isQualificationOther">{{ locale=='en'? bidSection.qualificationOtherDescribeEn:locale=='lo'?bidSection.qualificationOtherDescribeLo:bidSection.qualificationOtherDescribe }}</el-checkbox>

                        <!-- <el-checkbox disabled true-label="1" false-label="0" v-model="bidSection.isCertificateOfConformity">合格证</el-checkbox> -->
                    </div>
                </div>
                <!-- 标的物信息 -->
                <div class="border">
                    <div class="title" style="text-align: left">{{$t('view.标的物信息')}}</div>
                    <el-table  v-show="bidSection.sectionType!=1&&bidSection.engineeringType!=2" :data="sectors" max-height="530px" border header-row-class-name="tableHeader" style="margin: 20px 0 10px 0">
                        <el-table-column show-overflow-tooltip align="center" type="index" width="60" :label="$t('view.序号')"/>
                        <el-table-column show-overflow-tooltip align="center" prop="sectorTypeName" :label="$t('view.物资分类')" width="150">
                            <template slot-scope="scope">
                                {{locale=='en'? scope.row.sectorTypeNameEn:locale=='lo'?scope.row.sectorTypeNameLo:scope.row.sectorTypeName}}
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip align="center" prop="sectorName" :label="$t('view.物资名称')">

                            <template slot-scope="scope">
                                {{locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" show-overflow-tooltip prop="specifications" :label="$t('view.规格')">
                            <template slot-scope="scope">
                                {{locale=='en'? scope.row.specificationsEn:locale=='lo'?scope.row.specificationsLo:scope.row.specifications}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" show-overflow-tooltip prop="model" :label="$t('view.型号')">
                            <template slot-scope="scope">
                            {{locale=='en'? scope.row.modelEn:locale=='lo'?scope.row.modelLo:scope.row.model}}
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip align="center" prop="sectorNumber" :label="$t('view.需求数量')" width="100"></el-table-column>
                        <el-table-column align="center" show-overflow-tooltip prop="sectorUnits" :label="$t('view.计量单位')" width="100">
                            <template slot-scope="scope">
                            {{locale=='en'? scope.row.sectorUnitsEn:locale=='lo'?scope.row.sectorUnitsLo:scope.row.sectorUnits}}
                            </template>
                        </el-table-column>                        <el-table-column show-overflow-tooltip align="center" prop="remark" :label="$t('view.其他')"></el-table-column>
                        <el-table-column align="center"  show-overflow-tooltip :label="$t('view.附件')">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.outFileList.length" style="cursor: pointer; line-height: 20px;font-size: 14px;color:#409EFF" @click.stop="handleViewFile(scope.row.outFileList[0].filePath, scope.row.outFileList[0].fileName)">{{ scope.row.outFileList[0].fileName }}</span>
                                </template>
                            </el-table-column>
                    </el-table>
                    <el-table v-show="bidSection.sectionType==1" default-expand-all  :data="sectors" stripe   header-row-class-name="tableHeader" style="width: 100%">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-table :data="props.row.details"  border header-row-class-name="tableHeader" style="width: 100%">
                                    <el-table-column align="center" show-overflow-tooltip type="index" width="60" :label="$t('view.序号')"/>
                                    <!-- <el-table-column align="center" show-overflow-tooltip prop="sectorType" :label="$t('view.物资分类')"></el-table-column> -->
                                    <el-table-column align="center" show-overflow-tooltip prop="sectorName" :label="$t('view.物资名称')"></el-table-column>
                                    <el-table-column align="center" show-overflow-tooltip prop="remark" :label="$t('view.规格')">
                                        <template slot-scope="scope">
                                            {{ locale == 'en' ? scope.row.specificationsEn : locale == 'lo' ? scope.row.specificationsLo:scope.row.specifications}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column align="center" show-overflow-tooltip prop="remark" :label="$t('view.型号')">
                                        <template slot-scope="scope">
                                            {{ locale == 'en' ? scope.row.modelEn : locale == 'lo' ? scope.row.modelLo : scope.row.model }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column align="center" show-overflow-tooltip prop="sectorNumber" :label="$t('view.需求数量')"></el-table-column>
                                    <el-table-column align="center" show-overflow-tooltip prop="remark" :label="$t('view.计量单位')">
                                        <template slot-scope="scope">
                                            {{ locale == 'en' ? scope.row.detailUnitsEn : locale == 'lo' ? scope.row.detailUnitsLo:scope.row.detailUnits}}
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column v-if="details.budgetType==2" key="budgetAmount" align="center" show-overflow-tooltip prop="budgetAmount" :label="details.sectorBudgetType==1? $t('view.预算总价'):$t('view.预算单价')">
                                        <template slot-scope="scope">
                                            {{scope.row.budgetAmount}}{{moneyUnit}}
                                        </template>
                                    </el-table-column> -->

                                </el-table>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" show-overflow-tooltip type="index" width="60" :label="$t('view.序号')"/>
                        <el-table-column align="center" show-overflow-tooltip prop="sectorTypeName" :label="$t('view.标段名称')">
                            <template slot-scope="scope">
                                {{locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" show-overflow-tooltip prop="remark" width="300" :label="$t('view.其他')"></el-table-column>
                    </el-table>
                    <!-- 总包 -->
                    <el-table max-height="500" v-show="bidSection.engineeringType==2" border header-row-class-name="tableHeader" :data="sectors" style="width: 100%;margin-top: 15px;">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-table :data="props.row.details"  border header-row-class-name="tableHeader" style="width: 100%">
                                    <!-- 物资名称 -->
                                    <el-table-column align="center" width="200" show-overflow-tooltip  :label="$t('view.物资名称')">
                                        <template slot-scope="scope">
                                            {{locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName}}
                                        </template>
                                    </el-table-column>
                                    <!-- 规格 -->
                                    <el-table-column align="center" width="150" show-overflow-tooltip  :label="$t('view.规格')">
                                        <template slot-scope="scope">
                                            {{locale=='en'? scope.row.specificationsEn:locale=='lo'?scope.row.specificationsLo:scope.row.specifications}}
                                        </template>
                                    </el-table-column>
                                    <!-- 型号 -->
                                    <el-table-column align="center" width="150" show-overflow-tooltip  :label="$t('view.型号')">
                                        <template slot-scope="scope">
                                            {{locale=='en'? scope.row.modelEn:locale=='lo'?scope.row.modelLo:scope.row.model}}
                                        </template>
                                    </el-table-column>
                                    <!-- 需求数量 -->
                                    <el-table-column align="center" show-overflow-tooltip prop="number" :label="$t('view.需求数量')">
                                    </el-table-column>
                                    <!-- 计量单位 -->
                                    <el-table-column align="center" show-overflow-tooltip prop="detailUnits"  :label="$t('view.计量单位')">
                                    </el-table-column>
                                <!-- 报价方式 -->
                                    <el-table-column align="center" show-overflow-tooltip  :label="$t('view.报价方式')">
                                        <template slot-scope="scope">
                                            {{scope.row.quotationMethod==1?$t('view.总价'):$t('view.单价')}}
                                        </template>
                                    </el-table-column>
                                    <!-- 系数名称 -->
                                    <el-table-column align="center" show-overflow-tooltip prop="coefficientName"  :label="$t('view.系数名称')">
                                    </el-table-column>
                                    <!-- 预算 -->
                                    <el-table-column align="center" show-overflow-tooltip prop="budgetAmount"  :label="$t('view.预算金额')">
                                        <template slot-scope="scope">
                                            {{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}
                                            {{formatNum(scope.row.budgetAmount) }}
                                        </template>
                                    </el-table-column>
                                    <!-- 附件 -->
                                    <el-table-column align="center" show-overflow-tooltip :label="$t('view.附件')">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.outFileList.length" style="cursor: pointer; line-height: 20px;font-size: 14px;color:#409EFF" @click.stop="handleViewFile(scope.row.outFileList[0].filePath, scope.row.outFileList[0].fileName)">{{ scope.row.outFileList[0].fileName }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-table-column>
                        <el-table-column  align="center" :label="$t('view.标段名称')" width="260">
                            <template slot-scope="scope">
                                {{ locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center"  width="150" :label="$t('view.币种')">
                            <template slot-scope="scope">
                                {{getStatus('sys_currency',scope.row.currency)  }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="150" prop="moneyUnit" :label="$t('view.币种单位')">
                        </el-table-column>
                        <el-table-column align="center" prop="remark" :label="$t('view.备注')">
                        </el-table-column>
                    </el-table>
                </div>
                <div v-if="bidSection.sectorFileList&&bidSection.sectorFileList.length" style="color:#B80008; font-weight: bold; font-size: 16px;margin: 20px 0 10px 0;">{{$t('view.标的物附件：')}}</div>
                <div class="clickText" v-for="(item,index) in bidSection.sectorFileList" :key="index">
                    <!-- <File :file="item"></File> -->
                    <span style="line-height: 20px;font-size: 14px;color:#4F62E7;font-weight: bold" @click.stop="handleViewFile(item.filePath, item.fileName)">{{ item.fileName }}</span>
                </div>

                <div class="btnList" v-if="$route.name!='PreviewDetails' &&this.$route.query.biddingType!=0&&this.$route.query.biddingType!=1">
                    <el-button style="margin-left: 20px;min-width: 120px" plain @click="follow" type="success">{{ bidSection.isFollow==1?$t('view.已关注'):$t('view.关注')}}</el-button>
                    <el-button v-if="bidSection.sectionStauts==8" style="min-width: 120px;" type="success"  @click="warningTime">{{ bidSection.isSignup==1?$t('view.处理'):$t('view.报名') }}</el-button>
                </div>
                <!-- 按钮的位置 -->
                <div style="width: 100%;height: 60px;"></div>
            </div>
        </div>
        <!-- 个人报名认证 -->
        <el-dialog :title="$t('view.个人认证')" :visible.sync="personalOpen" width="800px" append-to-body :close-on-click-modal="false">
            <el-form ref="authentication" :model="authentication" label-width="80px" :rules="rules">
                <div style="color: #B80008; margin-left: 160px;"> {{operationMsg}} </div>
                <el-form-item :label="$t('view.身份证(正面)')+':'" prop="corporateIdCardFront" label-width="160px">
                    <div style="display: flex; flex-wrap: flex-start">
                    <vuedraggable :list="authentication.corporateIdCardFront" :animation="200">
                        <div class="demo-upload-list" v-for="(item, __index) in authentication.corporateIdCardFront" :key="__index" >
                        <template>
                            <img :src="item.filePath" class="upload-image"/>
                            <div class="demo-upload-list-cover">
                            <div>
                                <i class="el-icon-search"   size="30" @click="handleViewGoodsPicture(item.filePath)"></i>
                                <i class="el-icon-delete-solid"  size="30" @click="handleRemoveGoodsPicture(authentication.corporateIdCardFront,item)"></i>
                            </div>
                            </div>
                        </template>
                        </div>
                    </vuedraggable>
                    <el-upload action="#" :limit="3"
                        v-if="authentication.corporateIdCardFront.length == 0"
                        accept=".jpg, .jpeg, .png"  list-type="picture-card" :show-file-list="false"
                        :file-list="authentication.corporateIdCardFront" :http-request="corporateIdCardFrontUploadFile">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('view.身份证(反面)')+':'" prop="corporateIdCardOpposite" label-width="160px">
                    <div style="display: flex; flex-wrap: flex-start">
                    <vuedraggable :list="authentication.corporateIdCardOpposite" :animation="200">
                        <div class="demo-upload-list" v-for="(item, __index) in authentication.corporateIdCardOpposite" :key="__index">
                        <template>
                            <img :src="item.filePath" class="upload-image"/>
                            <div class="demo-upload-list-cover">
                            <div>
                                <i class="el-icon-search" size="30" @click="handleViewGoodsPicture(item.filePath)"></i>
                                <i class="el-icon-delete-solid" size="30" @click="handleRemoveGoodsPicture(authentication.corporateIdCardOpposite,item)"></i>
                            </div>
                            </div>
                        </template>
                        </div>
                    </vuedraggable>
                    <el-upload action="#" :limit="3"
                        v-if="authentication.corporateIdCardOpposite.length == 0" accept=".jpg, .jpeg, .png" list-type="picture-card"
                        :show-file-list="false" :file-list="authentication.corporateIdCardOpposite" :http-request="corporateIdCardOppositeUploadFile">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    </div>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAuthentication">{{ $t('view.确 定') }}</el-button>
                <el-button @click="cancel">{{ $t('view.取 消') }}</el-button>
            </div>
        </el-dialog>
        <!-- 审核提示 -->
        <el-dialog :title="$t('view.提示')" :visible.sync="promptOpen" width="700px" append-to-body :close-on-click-modal="false">
            <h1>{{promptText }}</h1>
            <div slot="footer" class="dialog-footer">
                <el-button @click="promptCancel">{{ $t('view.确 定') }}</el-button>
            </div>
        </el-dialog>

        <!-- 图片预览 -->
        <el-dialog :visible.sync="goodsPictureVisible" class="preview" :title="$t('view.图片预览')" :append-to-body="true"  width="60%">
        <img :src="previewGoodsPicture" style="max-width: 100%; margin: 0 auto; margin-bottom: 20px;display: block;"/>
        </el-dialog>
        <PowerOfAttorney ref="PowerOfAttorney"></PowerOfAttorney>
    </div>
  </template>

<script>
    import {getSectionByIdWithAuth,follow,quotationSignup,authorizationDownLoad,submitAuthorization, authorizationVerify, getAuthorization} from '@/api/project'
    import {uploadAndBpm} from "@/api/common/common";
    import vuedraggable from "vuedraggable";
    import XEUtils from "xe-utils";
    import {getDicts,warningTime} from '@/api/index';
    import PowerOfAttorney from '@/components/PowerOfAttorney.vue'
    export default {
        components: { vuedraggable ,PowerOfAttorney},
        data(){
            return{
                tableData1:[],
                sectors:[],//标的物集合
                moneyUnit:'',//单位
                bidSection:{},//招标信息对象
                tableData:[],
                locale: localStorage.getItem('locale')||'zh',
                sys_receiving_account_type:[], //收费信息里的类型
                sys_currency:[],//币种
                sys_section_type:[],
                sys_bidding_method:[],//招标方式
                supply_type:[],
                authentication:{
                    businessLicenseFileList:[],
                    isLegalRepresentative:"",
                    businessLicenseStart:null,
                    businessLicenseEnd:null,
                    corporateIdCardFront:[],
                    corporateIdCardOpposite:[],
                    authorizationFileList:[],
                    authorizationStart:null,
                    authorizationEnd:null
                }, // 企业认证
                // 个人认证
                personalOpen:false,
                promptOpen:false,
                promptText:'',
                previewGoodsPicture:"",
                operationMsg:"",
                goodsPictureVisible: false,
                // 表单校验
                rules: {
                    businessLicenseFileList: [
                    { required: true, message: this.$t('view.请上传营业执照'), trigger: "blur" }
                    ],
                    businessLicenseStart: [
                    { required: true, message: this.$t('view.请选择营业执照有效期'), trigger: "blur" }
                    ],
                    businessLicenseEnd: [
                    { required: true, message:this.$t('view.请选择营业执照有效期'), trigger: "blur" }
                    ],
                    isLegalRepresentative: [
                    { required: true, message: this.$t('view.请选择是否法人'), trigger: "change" }
                    ],
                    corporateIdCardFront: [
                    { required: true, message: this.$t('view.请上传身份证(正面)'), trigger: "change" }
                    ],
                    corporateIdCardOpposite: [
                    { required: true, message: this.$t('view.请上传身份证(反面)'), trigger: "change" }
                    ],
                    authorizationFileList: [
                    { required: true, message: this.$t('view.请上传投标授权委托书'), trigger: "change" }
                    ],
                    authorizationStart: [
                    { required: true, message: this.$t('view.请选择授权委托书有效时间'), trigger: "change" }
                    ],
                    authorizationEnd:[
                    { required: true, message: this.$t('view.请选择授权委托书有效时间'), trigger: "change" }
                    ],
                },
            }
        },
        async created() {
            await Promise.all([
                this.getDicts('sys_bidding_method'),
                this.getDicts('sys_section_type'),
                this.getDicts('supply_type'),
                this.getDicts('sys_receiving_account_type'),
                this.getDicts('sys_currency')
            ])
            this.getSectionByIdWithAuth()
        },
        methods:{
            warningTime(){
                warningTime().then(res=>{
                    if(res.data.error==0||res.data.error==1){
                        this.quotationSignup()
                    }else if(res.data.error==2){
                        this.promptText=this.$t('view.授权委托书已上传，目前正在审核中，请耐心等待')
                        this.promptOpen = true;
                    } else{
                        this.$refs.PowerOfAttorney.show(res.data.authorizationBook.status==3?res.data.authorizationBook:{status:res.data.authorizationBook.status}, res.data.day)
                    }
                })
            },
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                // 如果不是最后一行，不处理
                if (rowIndex !== this.tableData.length - 1) {
                    return { rowspan: 1, colspan: 1 };
                }

                // 检查最后一行右边内容是否为空
                const lastRow = this.tableData[this.tableData.length - 1];
                const isRightEmpty = !lastRow.RightValue || lastRow.RightValue.trim() === '';

                // 如果右边内容为空，则合并
                if (isRightEmpty) {
                    if (columnIndex === 0) { // LeftTitle列：保持不变
                        return { rowspan: 1, colspan: 1 };
                    } else if (columnIndex === 1) { // LeftValue列：向右合并3列（覆盖RightTitle和RightValue）
                        return { rowspan: 1, colspan: 3 };
                    } else if (columnIndex === 2 || columnIndex === 3) { // RightTitle和RightValue列：隐藏
                        return { rowspan: 0, colspan: 0 };
                    }
                }

                // 默认情况：不合并
                return { rowspan: 1, colspan: 1 };
            },
            Jump(url){
                this.$router.push(url)
            },
            handleViewFile(filePath, fileName) {
                const ext = filePath.substr(filePath.lastIndexOf('.') + 1, filePath.length)
                if (ext == 'pdf' || 'PDF') {
                    window.open(filePath, "_blank");
                } else {
                    const eLink = document.createElement("a");
                    eLink.download = fileName;
                    eLink.style.display = "none";
                    eLink.href = filePath;
                    document.body.appendChild(eLink);
                    eLink.click();
                    eLink.remove()
                }
            },
            // 报名
            quotationSignup(){

                // 校验当前用户是否需要企业认证
                authorizationVerify().then(res=>{
                    if(res.code==200){
                        if ('Auth' == res.data.operation) {
                            // 企业认证
                            this.reset();
                            if("0" == res.data.operationUserType){
                                let that=this
                                this.$confirm(that.$t('view.是否进行企业认证'), that.$t('view.提示'), {
                                    confirmButtonText:that.$t('view.确定'),
                                    cancelButtonText: that.$t('view.取消'),
                                    type: 'warning'
                                }).then(() => {
                                    that.$router.push('EnterpriseCertification')
                                })
                            }else{
                                this.personalOpen = true;
                            }
                            this.operationMsg = res.data.operationMsg;
                        }else if ('prompt' == res.data.operation){
                            this.promptText=this.$t('view.认证信息已上传，目前正在审核中，请耐心等待')
                            this.promptOpen = true;
                        }else if ('modify' == res.data.operation){
                            getAuthorization().then(res=>{
                                this.authentication = res.data;
                            });
                            // 企业认证
                            this.reset();
                            if("0" == res.data.operationUserType){
                                let that=this
                                this.$confirm(that.$t('view.是否进行企业认证'), that.$t('view.提示'), {
                                    confirmButtonText:that.$t('view.确定'),
                                    cancelButtonText: that.$t('view.取消'),
                                    type: 'warning'
                                }).then(() => {
                                    that.$router.push('EnterpriseCertification')
                                })
                            }else{
                                this.personalOpen = true;
                            }
                            this.operationMsg = res.data.operationMsg;
                        }else{
                            if(this.bidSection.isSignup==1){
                                this.$router.push({path:'/BidDetails',query:{id:this.bidSection.supplierSignupId}})
                            }else{
                                quotationSignup({sectionId:this.$route.query.id}).then(res=>{
                                    if(res.code==200){
                                        this.$message.success(this.$t('view.报名成功'));
                                        this.$router.push({path:'/BidDetails',query:{id:res.data.id}})
                                       
                                    }
                                    if(res.code==500){
                                        // status 1 待审核 2通过  3 驳回
                                        let status=res.data.status
                                        let msg= this.$t('view.贵单位供货类型信息与当前项目物资分类')+'"'+this.getStatus('supply_type',this.bidSection.projectMaterialType)+'"'+this.$t('view.不符，请确认是否符合招标要求并继续报名。')
                                         this.$confirm((status==1||status==3)?this.$t('view.检测到贵企业有正在审批的企业信息变更申请，请等待变更流程审批完成、企业信息更新生效后，再重新提交报名。') :msg, this.$t('view.提示'), {
                                            confirmButtonText:this.$t('view.确定'),
                                            cancelButtonText: this.$t('view.取消'),
                                            type: 'warning'
                                        }).then(() => {
                                            this.$router.push({path:'/EnterpriseCertificationDet',
                                            query:{
                                                sectionName:this.bidSection.sectionName, 
                                                sectionId:this.$route.query.id,
                                                userName:this.bidSection.businessContacts,
                                                projectMaterialType:this.bidSection.projectMaterialType,
                                                projectMaterialTypeName:this.getStatus('supply_type',this.bidSection.projectMaterialType),
                                            }})
                                        })
                                    }
                                })
                                
                            }
                        }

                    }
                })
                // if(this.bidSection.isSignup==1){
                //     this.$router.push({path:'/BidDetails',query:{id:this.bidSection.supplierSignupId}})
                // }else{
                //     quotationSignup({sectionId:this.$route.query.id}).then(res=>{
                //     if(res.code==200){
                //         this.$message.success('报名成功');
                //         this.$router.push({path:'/BidDetails',query:{id:res.data.id}})
                //         // this.bidSection.isSignup= this.bidSection.isSignup==1?0:1
                //     }
                // })
                // }
            },
            // 关注
            follow(){
                follow({sectionId:this.$route.query.id}).then(res=>{
                    if(res.code==200){
                        this.$message.success(this.bidSection.isFollow!=1?this.$t('view.关注成功'):this.$t('view.取消关注成功'));
                        this.bidSection.isFollow= this.bidSection.isFollow==1?0:1
                    }
                })
            },
            getDicts(type){
                return getDicts(type).then(res=>{
                    res.data.map(item=>{
                        item.dictLabel=this.locale=='en'?item.dictLabelEn:this.locale=='lo'?item.dictLabelLo:item.dictLabel
                    })
                    this[type]=res.data
                })
            },
            buildDetailRows(flatArr) {
                const result = [];
                const arr = [...flatArr];
                while (arr.length > 0) {
                    const LeftTitle = arr.shift() ?? '';
                    const LeftValue = arr.shift() ?? '';
                    const RightTitle = arr.shift() ?? '';
                    const RightValue = arr.shift() ?? '';
                    result.push({ LeftTitle, LeftValue, RightTitle, RightValue });
                }
                return result;
            },
            // 获取详情
            getSectionByIdWithAuth(){
                getSectionByIdWithAuth(this.$route.query.id).then(res=>{
                    this.bidSection=res.data.bidSection
                    this.sectors=res.data.sectors
                    this.moneyUnit = (this.locale=='en'?this.bidSection.moneyUnitEn:this.locale=='lo'?this.bidSection.moneyUnitLo:this.bidSection.moneyUnit);
                    let data =this.bidSection
                    let sceneAddress=''
                    if(data.sceneAddressEn||data.sceneAddressLo||data.sceneAddress){
                        sceneAddress=  this.locale=='en'?data.sceneAddressEn:this.locale=='lo'?data.sceneAddressLo:this.locale='zh'?data.sceneAddress:''
                    }
                    if(this.bidSection.isEntrustedBid==1){
                        this.tableData=this.buildDetailRows(
                        [
                           this.$t('view.招标单位'),data.organization,
                           this.$t('view.建设单位'),data.constructionOrganizationName ,
                            this.$t('view.项目类型'),this.getStatus('sys_section_type',data.projectType) ,
                            this.$t('view.物资分类'),this.getStatus('supply_type',data.projectMaterialType),
                           this.$t('view.招标方式'),this.getStatus('sys_bidding_method',data.biddingMethod),
                            this.$t('view.投标方式'),data.isSceneBidding==1?('('+this.$t('view.现场招标')+')'+(sceneAddress)):this.$t('view.线上招标'),
                            this.$t('view.中标方式'),data.successfulBidderMethod==1?this.$t('view.分项'):this.$t('view.整体'),
                            this.$t('view.是否提交投标文件'),this.$t('view.是否提交投标文件'),
                            this.$t('view.商务联系人/电话'),data.businessContacts+'/'+data.businessPhoneNumber,
                            this.$t('view.技术联系人/电话'),data.technicalContacts+'/'+data.technicalPhoneNumber,
                            this.$t('view.质保期'),data.warranty,
                            this.$t('view.是否含税'),this.bidSection.isTax=='1'?this.$t('view.是'):this.$t('view.否'),
                           this.$t('view.币种'),this.getStatus('sys_currency',this.bidSection.currency),
                            this.$t('view.开标时间'),data.startTime
                        ])

                    }else{
                        this.tableData=this.buildDetailRows(
                        [
                           this.$t('view.招标单位'),data.organization,
                           this.$t('view.项目类型'),this.getStatus('sys_section_type',data.projectType) ,
                            this.$t('view.物资分类'),this.getStatus('supply_type',data.projectMaterialType),
                            this.$t('view.招标方式'),this.getStatus('sys_bidding_method',data.biddingMethod) ,
                            this.$t('view.投标方式'),data.isSceneBidding==1?('('+this.$t('view.现场招标')+')'+(sceneAddress)):this.$t('view.线上招标'),
                            this.$t('view.中标方式'),data.successfulBidderMethod==1?this.$t('view.分项'):this.$t('view.整体'),
                            this.$t('view.是否提交投标文件'),this.$t('view.是否提交投标文件'),
                            this.$t('view.商务联系人/电话'),data.businessContacts+'/'+data.businessPhoneNumber,this.$t('view.技术联系人/电话'),
                           data.technicalContacts+'/'+data.technicalPhoneNumber,
                            this.$t('view.质保期'),data.warranty,
                           this.$t('view.是否含税'),this.bidSection.isTax=='1'?this.$t('view.是'):this.$t('view.否'),
                            this.$t('view.币种'),this.getStatus('sys_currency',this.bidSection.currency),
                            this.$t('view.开标时间'),data.startTime
                        ])
                    }
                    
                    if(data.isYuanJu==1){
                        this.tableData=this.buildDetailRows(
                        [
                            this.$t('view.招标单位'),data.organization,this.$t('view.项目类型'),
                            this.$t('view.物资分类'),this.getStatus('supply_type',data.projectMaterialType),
                            this.getStatus('sys_section_type',data.projectType) ,
                            this.$t('view.招标方式'),this.getStatus('sys_bidding_method',data.biddingMethod) ,this.$t('view.投标方式'),data.isSceneBidding==1?('('+this.$t('view.现场招标')+')'+(sceneAddress)):this.$t('view.线上招标'),
                            this.$t('view.中标方式'),data.successfulBidderMethod==1?this.$t('view.分项'):this.$t('view.整体'),this.$t('view.是否提交投标文件'),this.$t('view.是否提交投标文件'),
                            this.$t('view.商务联系人/电话'),data.businessContacts+'/'+data.businessPhoneNumber,this.$t('view.质保期'),data.warranty,
                            this.$t('view.开标时间'),data.startTime,this.$t('view.报名时间'),!data.signupStartTime?'':(data.signupStartTime+'-'+data.signupEndTime),
                            ])
                    }
                
                })
            },
            rowClass(row, column, rowIndex, columnIndex){
                if(row.column.property=='LeftTitle'||row.column.property=='RightTitle'){
                    return "background: #F2F6FC;color: #909399;"
                }
            },
            // 取消按钮
            cancel() {
                this.personalOpen = false;
                this.reset();
            },
            // 提示取消按钮
            promptCancel() {
                this.promptOpen = false;
            },
             // 表单重置
            reset() {
                this.authentication = {
                    businessLicenseFileList: [],
                    isLegalRepresentative:"",
                    businessLicenseStart:null,
                    businessLicenseEnd:null,
                    corporateIdCardFront:[],
                    corporateIdCardOpposite:[],
                    authorizationFileList:[],
                    authorizationStart:null,
                    authorizationEnd:null
                };
                this.resetForm("authentication");
            },
            // 提交
            submitAuthentication(){
                this.authentication.sectionId = this.bidSection.sectionId;
                this.authentication.sectionName = this.bidSection.sectionName;
                console.log(this.authentication);
                this.$refs["authentication"].validate(valid => {
                    if (valid) {
                        submitAuthorization(this.authentication).then(response => {
                            this.$message.success(this.$t('view.提交成功'));
                            this.personalOpen = false;
                            this.reset();
                        });
                    }
                });
            },
            handleViewGoodsPicture(url) {
                this.previewGoodsPicture = url;
                this.goodsPictureVisible = true;
            },
            corporateIdCardFrontUploadFile(data){
                this.uploadFile(data,this.authentication.corporateIdCardFront);
            },
            corporateIdCardOppositeUploadFile(data){
                this.uploadFile(data,this.authentication.corporateIdCardOpposite);
            },
            handleRemoveGoodsPicture(fileList,file) {
                XEUtils.remove(fileList, (item) => item.filePath === file.filePath); // el-upload 删除
            },
            // 下载模版
            downloadTemplate(){
                authorizationDownLoad().then(res=>{
                    const blob = new Blob([res]);
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = this.$t('view.投标授权委托书模板.docx');
                    link.click();
                })
            },
            // 附件上传
            uploadFile(data,fileList) {
                console.log(fileList);
                // 判断是否大于10M
                if (data.file.size / 1024 / 1024 > 1024) {
                    this.$message({
                    message: this.$t('view.上传文件不能超过20MB'),
                    type: "warning"
                    });
                    this.uploadLoading = false;
                    return;
                }
                if (data.file.size == 0) {
                    this.$message({
                    message: this.$t('view.上传文件不能为0KB'),
                    type: "warning"
                    });
                    return;
                }
                let formData = new FormData();
                formData.append("file", data.file);
                formData.append("type", "qyrzsp");
                uploadAndBpm(formData).then(response => {
                    if (response.code === 200) {
                        this.$message({ message: this.$t('view.上传成功'), type: "success" });
                        fileList.push(response.data);
                    }
                }).catch(err => {
                });
            },
        }
    };

</script>

<style lang="scss" scoped>
.title{
    padding: 20px 0;
    font-size: 24px;
    font-weight: 600;
    color: #333333;
    line-height: 33px;
    text-align: center;
}
.time{
    padding-bottom: 5px;
    border-bottom: solid 1px $Border-color;
    text-align: right;
    font-size: 14px;
    color: #999999;
}
.borderBottom{
    border-bottom: solid 1px $Border-color;
}
.borders{
    border: solid 1px $Border-color;
}
.border{
    width: 1200px;
    background: #fff;
    // margin-bottom: 20px;
}
.upload-image {
  width: 400px; /* 根据需要调整宽度 */
  height: auto; /* 保持宽高比 */
}
.btnList{
    text-align: center;
    position: fixed;
    bottom: 20px;
    height: 40px;
    width: 1200px;
    z-index: 9;
}
.borderBottom img{max-width:100%;height:auto;}
.crumbs{
    font-size: 16px;
    line-height: 35px;
    span{
        color: #999999;
    }
}
</style>
